import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
Vue.prototype.$axios = axios;
import './commonJs/ajax'
import QS from 'qs';
Vue.prototype.qs = QS;
import './style/common.css'
import './assets/iconfont/iconfont.css'
import Vant from 'vant';
Vue.use(Vant);
import 'vant/lib/index.css';
import commonjs from './commonJs/common'
Vue.prototype.$common = commonjs

Vue.config.productionTip = false

import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
var isBack=false

window.addEventListener('pageshow', function (event) {

  if(event.persisted || window.performance && window.performance.navigation.type == 2){
      isBack=true
      getUserInSession()
      // console.log('window.performance.navigation.type: '+ window.performance.navigation.type)
  }else{
    getUserInSession()
  }
},false);

// getUserInSession()
function getUserInSession() {
  Vue.prototype.$axios({
    method: 'get',
    url: baseUrl + '/app/casMember/getUserInSession'
  }).then((res) => {
    if ((typeof res) == 'string') {
      location.href = baseUrl + '/login/appLogin'
    } else if (res.success) {
      if (res.obj == null) {
        location.href = baseUrl + '/login/appLogin'
      } else {
        if (res.obj.memberSign != '1') {
          location.href = authenticationUrl + '/authentication/views/userinfo/changePwd_yesf.html?service=' + baseUrl + "/dist/index.html"
          return;
        }
        let roleList = [];
        res.obj.roleList.forEach(function (item, index) {
          roleList.push(item.roleCode)
        })
        store.commit('setMemberInfo', res.obj);
        console.log(isBack);
        
        if(!isBack){
          router.push('/index')
        }else{
          router.push(localStorage.getItem('routerPath'))
        }
      }
    }
  }).catch((error) => {

  })
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
